import { api } from '@/lib/axios';

export type NotificationNiveau = 'info' | 'warning' | 'danger';

export interface NotificationDTO {
  id: string;
  niveau: NotificationNiveau;
  titre: string;
  message: string;
  lien: string | null;
}

export async function listNotifications(): Promise<NotificationDTO[]> {
  const { data } = await api.get<NotificationDTO[]>('/notifications');
  return data;
}
